import { Component, effect, inject, OnDestroy } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormValidators } from '@corelabs/angular/forms';
import { ButtonModule } from 'primeng/button';
import { FormInputComponent, FormTextareaComponent, FormDatePickerComponent } from '@shared/forms';
import { NewsItemFacade } from '@app/store/news-item';

@Component({
    selector: 'app-news-add-modal',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.css'],
    imports: [ReactiveFormsModule, TranslateModule, ButtonModule, FormInputComponent, FormTextareaComponent, FormDatePickerComponent],
})
export class AddComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly newsItemFacade = inject(NewsItemFacade);
    private readonly formBuilder = inject(NonNullableFormBuilder);

    readonly saving = this.newsItemFacade.saving;

    readonly form = this.formBuilder.group({
        title: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        description: this.formBuilder.control('', [FormValidators.Required, FormValidators.Text]),
        date: this.formBuilder.control<Date | null>(null, [FormValidators.Required]),
    });

    constructor() {
        effect(() => {
            if (this.newsItemFacade.saved()) {
                this.close();
            }
        });

        effect(() => {
            if (this.newsItemFacade.saving() === false && this.newsItemFacade.saved() === false) {
                this.form.enable();
            }
        });
    }

    ngOnDestroy(): void {
        this.newsItemFacade.clear();
    }

    onSubmit(): void {
        this.form.markAllAsTouched();

        if (this.form.valid) {
            this.form.disable();
            this.newsItemFacade.createNewsItem(this.form.getRawValue());
        }
    }

    close(): void {
        this.router.navigate([{ outlets: { modal: null } }]);
    }
}
